import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";

import { actions } from "../slice";
import { handleError } from "../../app-messages";

export const fetchEvents = ({ jobseekerId }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/candidates/${jobseekerId}/events`);
      const { data } = handleAxiosResponse(response);
      dispatch(actions.getEvents(data));
      return { data };
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
